import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=fee5af34&scoped=true&"
import script from "./MediaBlock.vue?vue&type=script&lang=js&"
export * from "./MediaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee5af34",
  null
  
)

export default component.exports